module.exports = __webpack_public_path__ + "img/xh_map.9ccf87ed.png";